import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60030d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = ["value", "type", "placeholder", "required"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseField',
  props: {
    value: {},
    placeholder: {},
    required: { type: Boolean },
    type: {}
  },
  emits: ["update:value"],
  setup(__props: any, { emit }) {





function onInput(e: Event) {
	if (e.target) emit('update:value', (e.target as HTMLInputElement).value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps({
      class: "field__input form__input",
      onInput: onInput,
      value: _ctx.value,
      type: _ctx.type,
      placeholder: _ctx.placeholder,
      required: _ctx.required
    }, _ctx.$attrs), null, 16, _hoisted_2)
  ]))
}
}

})